import { render } from "./NeoCheckSubmitVideoID.vue?vue&type=template&id=831ca9a8&scoped=true"
import script from "./NeoCheckSubmitVideoID.vue?vue&type=script&lang=js"
export * from "./NeoCheckSubmitVideoID.vue?vue&type=script&lang=js"

import "./NeoCheckSubmitVideoID.vue?vue&type=style&index=0&id=831ca9a8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-831ca9a8"]])

export default __exports__